import Input, { type InputProps } from '@cobliteam/ui/form/Input';
import Icon from '@cobliteam/ui/icons';
import type { ReactNode } from 'react';

interface SelectDriverTriggerProps {
  placeholder?: string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  disabled?: boolean;
  withoutStartIcon?: boolean;
}

const SelectDriverTrigger = ({ placeholder = 'Sem motorista', disabled, withoutStartIcon = false, ...props }: SelectDriverTriggerProps & InputProps) => {
  // Known bug: when trigger is disabled the icons are still triggering the dropdown. Fixed by not showing icons on disabled state
  const startIcon = disabled || withoutStartIcon ? null : (props.startIcon ?? <Icon name='circle-user-round' color='gray-dark' className='pointer-events-none' />);
  const endIcon = disabled ? null : (props.endIcon ?? <Icon name='chevron-down' color='gray-dark' />);

  return (
    <div data-testid='driver-select'>
      <Input startIcon={startIcon} endIcon={endIcon} placeholder={placeholder} readOnly disabled={disabled} {...props} />
    </div>
  );
};

export default SelectDriverTrigger;
